import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { type IMultiDayJobPayload, type IPostMultiDayResponse } from '../types';

export async function postMultiDayShifts(
  officeId: string,
  jobInfo: IMultiDayJobPayload[],
): Promise<IPostMultiDayResponse> {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.post<IPostMultiDayResponse>('/multi-day', jobInfo, {
    headers: {
      ...headers,
      'x-office': officeId,
    },
  });

  return response.data;
}
